/*
* Report page
*/

import * as _ from 'lodash';
import moment from 'moment';
import * as React from 'react';

import { getLastNumber } from 'src/utils/numberUtils';
import ApiEndpoints from '../../../config/apiendpoints';
import * as ReportComponents from '../report-components';

export const Render = ({ analysisMethod, fundingGoal, reportData, appText, ...rest }) => {
    const { currentOrder, currentOrderChart, currentOrderUsers, branding, association, reportPeriodStartDate, reportPeriodEndDate } = reportData;

    // Determine manager permit # and show if nevada
    const permits = _.get(currentOrderUsers, 'manager.permits', []);
    const nvPermitNum = _.get(_.find(permits, ['location.stateCode', 'NV']), 'permitNumber', '');
    const nevadaPermitNumber = nvPermitNum && _.get(reportData, 'association.company.brandKey', '') === 'complex-solutions' &&
        _.get(reportData, 'association.location.stateCode') === 'NV' ?
        (<ReportComponents.CoverInfo title="NV Permit #" value={nvPermitNum} />) :
        (<div />);

    // Date of site visit
    const DefaultDateOfSiteVisit = 'N/A';
    let dateOfSiteVisit = DefaultDateOfSiteVisit;
    // 20200310 was: const dateOfSiteVisit = (_.get(currentOrder, 'serviceLevel.report') === ReportComponents.ReportOrderServiceLevels.level3) ? DefaultDateOfSiteVisit : ReportComponents.shortDate(_.get(currentOrder, 'siDueDate'));
    if (_.get(currentOrder, 'serviceLevel.report') === ReportComponents.ReportOrderServiceLevels.level3) {
        dateOfSiteVisit = DefaultDateOfSiteVisit;
    } else if (_.get(currentOrder, 'serviceLevel.report') === ReportComponents.ReportOrderServiceLevels.threeYearPlan) {
        if (currentOrder.serviceLevel.name) {
            switch (getLastNumber(currentOrder.serviceLevel.name)) {
                case 1:
                case 2:
                    const siDueDate = _.get(currentOrder, 'siDueDate');
                    if (siDueDate) {
                        if (siDueDate === '1970-01-01T00:00:00.000Z' || siDueDate === '1970-01-01T00:00:00.000+00:00' || siDueDate === '1970-01-01T00:00:00.000' || siDueDate === '1970-01-01T00:00:00.000+0000') {
                            dateOfSiteVisit = DefaultDateOfSiteVisit;
                        } else {
                            dateOfSiteVisit = ReportComponents.shortDate(siDueDate);
                        }
                    }
                    break;
                case 3:
                    dateOfSiteVisit = DefaultDateOfSiteVisit;
                    break;
                default:
                    break;
            }
        }
    } else {
        const siDueDate = _.get(currentOrder, 'siDueDate');
        if (siDueDate) {
            if (siDueDate === '1970-01-01T00:00:00.000Z' || siDueDate === '1970-01-01T00:00:00.000+00:00' || siDueDate === '1970-01-01T00:00:00.000' || siDueDate === '1970-01-01T00:00:00.000+0000') {
                dateOfSiteVisit = DefaultDateOfSiteVisit;
            } else {
                dateOfSiteVisit = ReportComponents.shortDate(siDueDate);
            }
        }
    }
    // console.log(`report-page-cover dateOfSiteVisit ${dateOfSiteVisit}`, { currentOrder });

    const reportStartDateShort = ReportComponents.shortDate(moment(reportPeriodStartDate).toDate());
    const reportEndDateShort = ReportComponents.shortDate(moment(reportPeriodEndDate).toDate());

    const reportPeriodText = `Report Period - ${reportStartDateShort} to ${reportEndDateShort}`;

    // console.log('report-page-cover data', {
    //     reportEndDateShort: reportEndDateShort,        
    //     reportPeriodEndDate: reportPeriodEndDate,
    //     reportPeriodStartDate: reportPeriodStartDate,
    //     reportPeriodText: reportPeriodText,
    //     reportStartDateShort: reportStartDateShort,
    // });

    let typeOfStudy = _.get(currentOrder, 'serviceLevel.report', '');
    switch (_.get(currentOrder, 'serviceLevel.report', ReportComponents.ReportOrderServiceLevels.level1)) {
        case ReportComponents.ReportOrderServiceLevels.level1:
            typeOfStudy = 'Full Study';
            break;

        case ReportComponents.ReportOrderServiceLevels.level2:
            typeOfStudy = 'Update with Site Visit';
            break;

        case ReportComponents.ReportOrderServiceLevels.level3:
            typeOfStudy = 'Update without Site Visit';
            break;

        case ReportComponents.ReportOrderServiceLevels.threeYearPlan:
            switch (getLastNumber(currentOrder.serviceLevel.name)) {
                case 1:
                    typeOfStudy = 'Full Study';
                    break;
                case 2:
                    typeOfStudy = 'Update with Site Visit';
                    break;
                case 3:
                    typeOfStudy = 'Update without Site Visit';
                    break;
                default:
                    break;
            }
            break;

        case null:
            typeOfStudy = 'Full Study';
            break;

        default:
            typeOfStudy = _.get(currentOrder, 'serviceLevel.report', '');
            break;
    }

    const twoOptionPricing = _.get(currentOrder, 'twoOptionPricing', false);
    const reportLevel = (twoOptionPricing) ?
        (getLastNumber(currentOrder.serviceLevel.name) === 1 ||
            getLastNumber(currentOrder.serviceLevel.name) === 2) ? 'Full' : 'Update' :
        currentOrder.serviceLevel.name ?
            'Level ' + getLastNumber(currentOrder.serviceLevel.name) :
            '';

    // 20200313 Fetch cover page picture
    // const imgSrc = ApiEndpoints.getAppOrderPictureUrl(currentOrder.coverPagePicture, false, true); // 20200313 Deprecated: Migration to AWS S3 src for all pictures
    const imgSrc = ApiEndpoints.getInventoryPictureUrl(currentOrder.coverPagePicture, true, 'h_300,f_auto/'); // NOT YET IMPORTED
    const showNumberofUnits = (_.get(association, 'details.numberUnits') && !(_.get(currentOrderChart, 'hideNumberOfUnits'))) ? (<ReportComponents.CoverInfo title="Number of Units" value={association.details.numberUnits} />) : (<div />);

    return (
        <div>
            <ReportComponents.ReportPage className="pdf-page-cover-page" reportData={reportData}>
                <div className="pdf-cover-page-title-container">
                    <div className="pdf-page-cover-page-title">{association.name}</div>
                    <div className="pdf-page-cover-page-subtitle">{currentOrder.isPreliminaryStudy ? "Preliminary Reserve Study" : `${reportLevel} Reserve Study`}</div>
                </div>

                <div className="pdf-page-cover-page-padded-container">
                    <div>
                        <img className="pdf-page-cover-page-picture" src={imgSrc} />
                        <div className="pdf-page-cover-page-report-period">
                            <span className="pdf-page-cover-page-report-period-text">{reportPeriodText}</span>
                        </div>
                    </div>

                    <div className="pdf-page-cover-page-info-block center-block text-left">
                        <ReportComponents.CoverInfo title="Client Reference Number" value={association.associationId} />

                        <ReportComponents.CoverInfo title="Property Type" value={association.associationType.name} />

                        {showNumberofUnits}

                        <ReportComponents.CoverInfo title="Fiscal Year End" value={association.details.fiscalYearEnd} />
                    </div>

                    <div className="pdf-page-cover-page-info-block center-block text-left">
                        <ReportComponents.CoverInfo title="Type of Study" value={currentOrder.isPreliminaryStudy ? "Preliminary Study" : typeOfStudy} />

                        <ReportComponents.CoverInfo title="Date of Site Visit" value={dateOfSiteVisit} />

                        <ReportComponents.CoverInfo title="Prepared By" value={`${currentOrder.user.firstName} ${currentOrder.user.lastName}`} />

                        {nevadaPermitNumber}

                        <ReportComponents.CoverInfo title="Analysis Method" value={analysisMethod} />

                        <ReportComponents.CoverInfo title="Funding Goal" value={fundingGoal} />
                    </div>

                    <div className="center-block">
                        <div className="pdf-page-cover-page-report-prepared">Report prepared on - {currentOrder.reportDate ? ReportComponents.monthDate(currentOrder.reportDate) : ReportComponents.monthDate(Date.now())}</div>
                    </div>

                    <div className="center-block pdf-page-cover-page-footer-wrapper">
                        <img className="pdf-page-cover-page-logo" src={reportData.branding.logoCoverPage} />

                        <div className="pdf-page-cover-page-company-wrapper">
                            <ReportComponents.CoverCompany company={_.get(association, 'company', {})} />
                        </div>
                    </div>
                </div>
            </ReportComponents.ReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-cover.tsx